module.exports = __webpack_public_path__ + "static/media/elsa.aa0992d0.jpg";